export default {
  reward_title: "Invite Rewards",
  reward_desc_dynamic:
    "For each friend you successfully invite to register, you will receive {0} calculation rewards",
  invite_friend: "Invite Friends",
  friend_email: "Friend's Email",
  email_placeholder: "Please enter your friend's email",
  send_invite: "Send Invite",
  invite_instructions: "Invitation Instructions",
  email_invitation_validity_dynamic: "Email invitations are valid for {0} days",
  link_invitation_permanent: "Link invitations are permanently valid",
  instruction_1_dynamic:
    "For each successful invitation, both you and your friend will receive {0} calculation credits",
  instruction_2:
    "Rewards will be automatically issued after your friend accepts the invitation and registers successfully",
  instruction_3:
    "Reward credits can be used for carbon emission calculations and are valid according to your subscription plan",
  invite_stats: "Invitation Statistics",
  total_invites: "Total Invitations",
  accepted_invites: "Accepted Invitations",
  reward_credits: "Reward Credits",
  invite_link: "Personal Invitation Link",
  reward_rules: "Reward Rules",
  reward_rule_1_dynamic:
    "For each successful invitation, you will receive {0} calculation credits as a reward",
  reward_rule_2:
    "Reward credits will be automatically added to your account and can be used for carbon emission calculations",
  reward_rule_3:
    "If cheating is detected, we reserve the right to cancel rewards and ban the account",
  email_required: "Please enter an email address",
  email_invalid: "Invalid email format",
  invite_sent: "Invitation sent",
  send_failed: "Failed to send invitation",
  fetch_failed: "Failed to fetch invitation information",
  copy_success: "Copied successfully",
  email_invitation: "Email Invitation",
  link_invitation: "Link Invitation",
  status_pending: "Pending",
  status_accepted: "Accepted",
  status_expired: "Expired",
  reward_issued: "Issued",
  pending: "Pending",
  reward_pending_tip: "Rewards will be issued after your friend completes their first calculation",
  expiring_soon: "Expiring Soon",
  no_invitations: "No invitation records",
  invitee_id: "Invitee ID",
  type: "Invitation Type",
  email: "Email",
  status: "Status",
  reward_status: "Reward Status",
  invite_time: "Invitation Time",
  expire_time: "Expiration Time",
  my_invitations: "My Invitations",
  invite_created_title: "Invitation Link",
  invite_created_desc:
    "Failed to send email. Please manually send the following link to your friend:",
  total_invitations: "Total {0} records",
  search_invitations: "Search invitations...",
  confirm: "Confirm",
};
